
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"21"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M15 6a7.008 7.008 0 017 7v7a1 1 0 01-1 1h-4a1 1 0 01-1-1v-7a1 1 0 00-2 0v7a1 1 0 01-1 1H9a1 1 0 01-1-1v-7a7.008 7.008 0 017-7zm5 13v-6a5 5 0 00-10 0v6h2v-6a3 3 0 016 0v6zM1 7h4a1 1 0 011 1v12a1 1 0 01-1 1H1a1 1 0 01-1-1V8a1 1 0 011-1zm3 2H2v10h2zM3 0a3 3 0 11-3 3 3 3 0 013-3zm0 4a1 1 0 10-1-1 1 1 0 001 1z"}})])
          )
        }
      }
    